import React from "react";

export default class PositionMonitor extends React.Component{
    constructor(props){
        super(props)
        this.ref = React.createRef()
        this.callback = this.measure.bind(this)
    }

    measure(){
        this.props.children(this.ref.current.getBoundingClientRect())
    }

    componentDidMount() {
        window.addEventListener('resize', this.callback)
        window.setTimeout(this.callback, 10)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.callback)
    }

    render(){
        return <div ref={this.ref}/>
    }
}